(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('ReportDetailsDialogController', ReportDetailsDialogController);

    function ReportDetailsDialogController(logger, config, $uibModalInstance, $translate, params, jsReportService) {
        var vm = this;

        vm.params = params;

        vm.gridOptions = {
            columnDefs: [
                {
                    displayName: $translate.instant('employee'),
                    name: 'employeeName',
                    enableColumnMenu: false
                }, {
                    displayName: $translate.instant('skill'),
                    name: 'actionName',
                    enableColumnMenu: false,
                    minWidth: 200,
                    visible: params.type === 'department'
                }, {
                    displayName: $translate.instant('department'),
                    name: 'departmentName',
                    enableColumnMenu: false,
                    minWidth: 150,
                    visible: params.type === 'skill' && !config.settings.onlyAssignToFunctions
                }, {
                    displayName: $translate.instant('function'),
                    name: 'functionName',
                    minWidth: 150,
                    enableColumnMenu: false,
                    visible: true
                }, {
                    displayName: $translate.instant('progress'),
                    name: 'progress',
                    cellTemplate: '/app/templates/common/userquality-progress-cell.tpl.html',
                    enableColumnMenu: false,
                    width: 125,
                    enableFiltering: false
                }, {
                    displayName: $translate.instant('expiry_date'),
                    name: 'dateOfExpiry',
                    cellTemplate: '/app/templates/common/date-of-expiry-cell.tpl.html',
                    width: 125,
                    enableColumnMenu: false,
                    enableFiltering: false
                }
            ]
        };
        
        vm.close = close;
        vm.downloadExcel = downloadExcel;
        vm.downloadPdf = downloadPdf;

        loadQualities();

        function _downloadReport(type) {
            var reportInfo = Object.assign(vm.params, { onlyAssignToFunctions: config.settings.onlyAssignToFunctions });
            var items = vm.gridOptions.data;
            
            return jsReportService.getReportDetails(type, reportInfo, items);
        }

        function close() {
            $uibModalInstance.dismiss();
        }

        function downloadExcel() {
            return _downloadReport('xlsx');
        }

        function downloadPdf() {
            return _downloadReport('pdf');
        }

        function loadQualities() {
            vm.gridOptions.data = vm.params.data;
        }
    }
})();
